import { render, staticRenderFns } from "./VariableShiftSelect.vue?vue&type=template&id=580bf8d2&"
import script from "./VariableShiftSelect.vue?vue&type=script&lang=js&"
export * from "./VariableShiftSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports